var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "product-filters product-filters__desktop" },
    [
      _c("div", { staticClass: "product_list__filters-wrapper" }, [
        _c("form", [
          _vm.productFiltersObject
            ? _c("div", { staticClass: "product_list__filters" }, [
                _vm.productFiltersObject.materials
                  ? _c("div", { staticClass: "product_list__filters__group" }, [
                      _c("div", [
                        _c("h3", [
                          _vm.languageStrings.all_materials
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.languageStrings.all_materials)
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          _vm._l(
                            _vm.productFiltersObject.materials,
                            function (materialItem, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "filter-item" },
                                [
                                  _c("div", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.tagFilters,
                                          expression: "tagFilters",
                                        },
                                      ],
                                      attrs: {
                                        id: materialItem.slug,
                                        name: materialItem.slug,
                                        type: "checkbox",
                                      },
                                      domProps: {
                                        value: materialItem.slug,
                                        checked: Array.isArray(_vm.tagFilters)
                                          ? _vm._i(
                                              _vm.tagFilters,
                                              materialItem.slug
                                            ) > -1
                                          : _vm.tagFilters,
                                      },
                                      on: {
                                        change: [
                                          function ($event) {
                                            var $$a = _vm.tagFilters,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = materialItem.slug,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.tagFilters = $$a.concat([
                                                    $$v,
                                                  ]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.tagFilters = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.tagFilters = $$c
                                            }
                                          },
                                          _vm.filterEvent,
                                        ],
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      { attrs: { for: materialItem.slug } },
                                      [_vm._v(_vm._s(materialItem.name))]
                                    ),
                                  ]),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.productFiltersObject.tags
                  ? _c("div", { staticClass: "product_list__filters__group" }, [
                      _c(
                        "div",
                        [
                          _c("h3", [
                            _vm.languageStrings.all_shapes
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.languageStrings.all_shapes)
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _vm._l(
                            _vm.productFiltersObject.tags,
                            function (tagItem, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "filter-item" },
                                [
                                  _c("div", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.tagFilters,
                                          expression: "tagFilters",
                                        },
                                      ],
                                      attrs: {
                                        id: "tags" + tagItem.slug,
                                        name: "tags" + tagItem.slug,
                                        type: "checkbox",
                                      },
                                      domProps: {
                                        value: tagItem.slug,
                                        checked: Array.isArray(_vm.tagFilters)
                                          ? _vm._i(
                                              _vm.tagFilters,
                                              tagItem.slug
                                            ) > -1
                                          : _vm.tagFilters,
                                      },
                                      on: {
                                        change: [
                                          function ($event) {
                                            var $$a = _vm.tagFilters,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = tagItem.slug,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.tagFilters = $$a.concat([
                                                    $$v,
                                                  ]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.tagFilters = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.tagFilters = $$c
                                            }
                                          },
                                          _vm.filterEvent,
                                        ],
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      { attrs: { for: "tags" + tagItem.slug } },
                                      [_vm._v(_vm._s(tagItem.name))]
                                    ),
                                  ]),
                                ]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.productFiltersObject.interfaces
                  ? _c("div", { staticClass: "product_list__filters__group" }, [
                      _c(
                        "div",
                        [
                          _c("h3", [
                            _vm.languageStrings.all_interfaces
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.languageStrings.all_interfaces)
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _vm._l(
                            _vm.productFiltersObject.interfaces,
                            function (interfaceItem, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "filter-item" },
                                [
                                  _c("div", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.tagFilters,
                                          expression: "tagFilters",
                                        },
                                      ],
                                      attrs: {
                                        id: "interface" + interfaceItem.slug,
                                        name: "interface" + interfaceItem.slug,
                                        type: "checkbox",
                                      },
                                      domProps: {
                                        value: interfaceItem.slug,
                                        checked: Array.isArray(_vm.tagFilters)
                                          ? _vm._i(
                                              _vm.tagFilters,
                                              interfaceItem.slug
                                            ) > -1
                                          : _vm.tagFilters,
                                      },
                                      on: {
                                        change: [
                                          function ($event) {
                                            var $$a = _vm.tagFilters,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = interfaceItem.slug,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.tagFilters = $$a.concat([
                                                    $$v,
                                                  ]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.tagFilters = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.tagFilters = $$c
                                            }
                                          },
                                          _vm.filterEvent,
                                        ],
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        attrs: {
                                          for: "interface" + interfaceItem.slug,
                                        },
                                      },
                                      [_vm._v(_vm._s(interfaceItem.name))]
                                    ),
                                  ]),
                                ]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }